import { render, staticRenderFns } from "./SaleProductSidebar.vue?vue&type=template&id=293f2fca&scoped=true&"
import script from "./SaleProductSidebar.vue?vue&type=script&lang=js&"
export * from "./SaleProductSidebar.vue?vue&type=script&lang=js&"
import style0 from "./SaleProductSidebar.vue?vue&type=style&index=0&id=293f2fca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293f2fca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('293f2fca')) {
      api.createRecord('293f2fca', component.options)
    } else {
      api.reload('293f2fca', component.options)
    }
    module.hot.accept("./SaleProductSidebar.vue?vue&type=template&id=293f2fca&scoped=true&", function () {
      api.rerender('293f2fca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/components/SaleProductSidebar.vue"
export default component.exports